<template>
  <div class="bg-light">
    <top-bar title="Sacola"></top-bar>
    <c-sacola :isComponent="true"/>
    <div style="padding-top: 106px" v-if="qtdSacola > 0">
      <div class="bg-white border-top fixed-bottom fixed-container">
        <div class="p-3">
          <a href="javascript:" @click="finalizar()" class="btn btn-primary btn-block btn-bottom mx-auto" style="max-width: 500px; min-height: 53px">
            <div class="d-flex align-items-center justify-content-center animated bounceIn">
              <b>Finalizar Pedido</b>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from '../components/TopBar'
  import CSacola from "../components/CSacola";
  import Icon from "../components/Icon";

  export default {
    name: 'Sacola',
    components: { CSacola, TopBar, Icon },
    data() {
      return {
        token: localStorage.getItem('token'),
        url: ''
      }
    },

    methods: {
      finalizar() {
        this.$helpers.trackPixel(this, 'InitiateCheckout', this.empresa);
        this.$helpers.trackAnalytics("begin_checkout", {
          currency: "BRL",
          value: this.dados.total,
          items: this.dados.produtos.map(dados => {
            return {
              item_id: dados.produto.id_tabela_preco,
              item_name: dados.produto.nome_produto,
              quantity: dados.quantidade
            }
          })
        });

        if (this.zap) {
          this.$router.push(this.url + '/perfil/login');

        } else {
          this.$router.push(this.url + (this.token ? '/finalizar' : '/perfil/cadastro'));
        }
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.empresa.dominio_delivery : '';
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      dados() {
        return this.$store.state.sacola;
      },

      qtdSacola() {
        return this.$store.state.sacola.produtos.length;
      },

      zap() {
        return this.$store.state.zap
      }
    }
  }
</script>

<style scoped>
</style>
